package com.parmartechnologies.commerce.feature.inventory.viewModel.size

import com.parmartechnologies.core.feature.inventory.size.model.Size
import com.parmartechnologies.core.feature.inventory.size.network.CreateSizeRequest
import com.parmartechnologies.core.feature.inventory.size.network.RetrieveSizeRequest
import com.parmartechnologies.core.feature.inventory.size.network.UpdateSizeRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.inventory.handler.SizeHandler
import com.parmartechnologies.commerce.feature.inventory.network.size.SizeNetwork
import com.parmartechnologies.commerce.feature.inventory.repository.SizeRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.storage.table.inventory.size.SizeDatabaseTable
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class SizeViewModel(val business: Business, val repository: SizeRepository = SizeHandler.shared().repository) :
    AppViewModel() {

    val allSize: StateFlow<List<Size>>
        get() = repository.sizeLiveData

    val selectedSize: StateFlow<Size?>
        get() = repository.selectedSize

    fun fetchAllSize() {
        loadFromStorage()
        if (allSize.value.isEmpty()) {
            val request =
                RetrieveSizeRequest(business._id)
            // startLoading()
            scope.launch {
                SizeNetwork().retrieve(request) {
                    stopLoading()
                    SizeDatabaseTable().insert(it?.payload) {}
                    loadFromStorage()
                }
            }
        }
    }

    fun loadAllSize() {
            fetchAllSize()
    }

    private fun loadFromStorage() {
        SizeDatabaseTable().retrieve(business._id) { data ->
            scope.launch {
                repository.sizeLiveData.emit(data)
            }
        }
    }

    fun getSizeById(id: String?, callback: (Size?) -> Unit) {
        SizeDatabaseTable().find(id ?: "") { data ->
            scope.launch {
                callback(data)
            }
        }
    }

    fun createNewSize(name: String, value: String, description: String, completion: () -> Unit) {
        val request = CreateSizeRequest(
            name,
            value,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            SizeNetwork().create(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allSize: MutableList<Size> =
                            repository.allSize.value.toMutableList()
                        allSize.add(it.payload!!)
                        repository.sizeLiveData.emit(allSize)
                        SizeDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }

    fun updateSize(name: String, id: String, value: String, description: String, completion: () -> Unit) {
        val request = UpdateSizeRequest(
            name,
            id,
            value,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            SizeNetwork().update(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allSize: MutableList<Size> =
                            repository.allSize.value.toMutableList()
                        allSize.add(it.payload!!)
                        repository.sizeLiveData.emit(allSize)
                        SizeDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }
}